/**
 * emailService.js
 *
 * Wraps @emailjs/browser for sending contact-form emails.
 *
 * Required EmailJS template variables (set these up in your EmailJS template):
 *   {{from_name}}   — sender's name
 *   {{from_email}}  — sender's email
 *   {{subject}}     — message subject
 *   {{message}}     — message body
 *   {{to_name}}     — recipient name (optional, e.g. "Fagierrands Support")
 *
 * Environment variables (set in .env):
 *   REACT_APP_EMAILJS_SERVICE_ID
 *   REACT_APP_EMAILJS_TEMPLATE_ID
 *   REACT_APP_EMAILJS_PUBLIC_KEY
 */

import emailjs from '@emailjs/browser';

const SERVICE_ID  = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

/**
 * Send a contact-form message via EmailJS.
 *
 * @param {{ name: string, email: string, subject: string, message: string }} formData
 * @returns {Promise<{ success: boolean, message: string }>}
 */
export async function sendContactEmail({ name, email, subject, message }) {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    console.error(
      '[emailService] Missing EmailJS env vars. ' +
      'Set REACT_APP_EMAILJS_SERVICE_ID, REACT_APP_EMAILJS_TEMPLATE_ID, and REACT_APP_EMAILJS_PUBLIC_KEY in .env'
    );
    return {
      success: false,
      message: 'Email service is not configured. Please contact us directly at support@fagierrands.com.',
    };
  }

  const templateParams = {
    from_name:  name,
    from_email: email,
    subject:    subject,
    message:    message,
    to_name:    'Fagierrands Support',
  };

  try {
    await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
    return { success: true, message: 'Message sent! We\'ll get back to you shortly.' };
  } catch (error) {
    console.error('[emailService] Failed to send email:', error);
    return {
      success: false,
      message: 'Failed to send your message. Please try again or reach us on WhatsApp.',
    };
  }
}
